
        <div class="modal__container" #container tabindex="1"
                [ngClass]="{'modal__invisible': !isVisible}">
        </div>
    